var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-page"},[_c('div',{staticClass:"web-page__content",class:{ 'has-footer': _vm.hasFooter }},[_vm._t("default")],2),(_vm.hasFooter)?_c('div',{staticClass:"web-page-footer"},[_c('div',{staticClass:"web-page-footer__content"},[_vm._t("actions")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }